import { ButtonList } from '../entities/button';

export const CreateAlarmPage = () => {

  return (
    <ButtonList createAlarmMode={true} />
  );

};
